export const calculateMonthlyPayment = (
  principalAmount: number,
  rate: number,
  tenure: number
): number => {
  if (rate < 0) {
    // throw Error('Rate should be greater than 0');
    return 0;
  }
  if (tenure <= 0) {
    return 0;
    // throw Error('Tenure should be greater than 0');
  }
  if (principalAmount <= 0) {
    return 0;
    // throw Error('PrincipalAmount should be greater than 0');
  }
  const denominator = tenure;
  if (denominator === 0) {
    return 0;
  }
  const totalRate = rate * (tenure / 12);
  const numerator = principalAmount * (1 + totalRate);
  return numerator / denominator;
};
